import React, { useEffect } from "react";
import Dashboard from "./Dashboard";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import {
  useGetAllSalesReportMutation,
} from "src/services/DashboardService"; // adjust path as needed
import moment from "moment";
import {
  setMonthlySales,
  setMonthlySalesLoading,
  setTodaySales,
  setTodaySalesLoading,
  setWeeklySales,
  setWeeklySalesLoading,
} from "src/redux/slices/DashboardSlice";
import { useDispatch } from "react-redux";

const DashboardWrapper = () => {
  const today = moment();
  const startOfMonth = moment(today).startOf("month");
  const startOfWeek = moment(today).startOf("week");
  const dispatch = useDispatch();

  const [salesReport] = useGetAllSalesReportMutation();

  useEffect(() => {
    const fetchSalesData = async () => {
      dispatch(setTodaySalesLoading(true));
      dispatch(setMonthlySalesLoading(true));
      dispatch(setWeeklySalesLoading(true));

      try {
        // Daily
        const todayRes: any = await salesReport({
          dateFilter: {
            startDate: today.format("YYYY-MM-DD"),
            endDate: today.format("YYYY-MM-DD"),
          },
        });
        if (todayRes?.data?.status) {
          dispatch(setTodaySales(todayRes.data.data || []));
        }

        // Weekly
        const weeklyRes: any = await salesReport({
          dateFilter: {
            startDate: startOfWeek.format("YYYY-MM-DD"),
            endDate: today.format("YYYY-MM-DD"),
          },
        });
        if (weeklyRes?.data?.status) {
          dispatch(setWeeklySales(weeklyRes.data.data || []));
        }

        // Monthly
        const monthlyRes: any = await salesReport({
          dateFilter: {
            startDate: startOfMonth.format("YYYY-MM-DD"),
            endDate: today.format("YYYY-MM-DD"),
          },
        });
        if (monthlyRes?.data?.status) {
          dispatch(setMonthlySales(monthlyRes.data.data || []));
        }
      } catch (error) {
        console.error("Error fetching sales data:", error);
      } finally {
        dispatch(setTodaySalesLoading(false));
        dispatch(setWeeklySalesLoading(false));
        dispatch(setMonthlySalesLoading(false));
      }
    };

    fetchSalesData();
  }, [dispatch, salesReport]);

  return (
    <SideNavLayout>
      <Dashboard />
    </SideNavLayout>
  );
};

export default DashboardWrapper;
